import React from 'react';
import queryString from "query-string";
import {getCasinoObj} from "../../../casino-utils";
import {mobileStyle} from "../../../style";

const CasinoCard = ({ title, navKey, img, isLoggedIn, history, openLogin, className, style}) => {
    
    return (
        <>
            {/* <style dangerouslySetInnerHTML={{__html: mobileStyle}} /> */}
        <a
            className={className}
            onClick={() => navKey ? isLoggedIn ? history.push(`/game-play/casino?${queryString.stringify(getCasinoObj(navKey))}`) : openLogin() : null}
            style={style ? style : {gridColumn: 'span 2'}}>
            <dl className="casino-title">
                <dt>{title}</dt>
                <dd>
                     <span ></span>
                      <span ></span>
                       <span ></span>
                        <span ></span>
                    play now
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="darkred" style={{marginLeft: '-1px', verticalAlign: 'middle'}}>
                        <path d="M8,5.14V19.14L19,12.14L8,5.14Z" />
                    </svg>
                    </dd>
            </dl>
            <img src={img} alt={title} draggable="false"/>
        </a>
        </>
    )
}

export default CasinoCard;
